<template>
  <section class="row" :id="id">
    <header class="col-xs-12">
      <h3>{{ title }}</h3>
    </header>
    <main class="col-xs-12">
      <data-table
        ref="vuetable"
        :title="title"
        :dados="itens"
        :fields="fields"
        :carregando="false"
        :per_page="10"
        @vuetable-pagination:change-page="checkAllCheckboxOnPage"
      >
        <template slot="header-actions">
          <div class="col-xs-12 col-sm-6 col-md-3" style="padding-left: 0">
            <label>Data Base</label>
            <datepicker v-model="dataBase" name="data_base" ref="data_base" />
          </div>
          <div
            class="container-action col-xs-12 col-sm-6 col-md-9"
            style="padding-left: 0"
          >
            <label>Ações</label>
            <div class="button-group">
              <a
                @click="alternarTodosCheckboxNaPagina"
                title="Selecionar todos os candidatos"
              >
                <font-awesome-icon
                  v-if="hasAllCheckboxOnPage"
                  :icon="iconChecked"
                  size="2x"
                />
                <font-awesome-icon v-else :icon="iconCheck" size="2x" />
              </a>
              <button
                title="Nomear Candidato"
                class="btn btn-success btn-xs"
                @click="nomearSelecionados"
                :disabled="!Boolean(dataBase) || loading.nomear"
              >
                <font-awesome-icon
                  v-if="loading.nomear"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'check'" />
                Nomear
                <span class="sr-only">Nomear Candidato</span>
              </button>
              <button
                title="Empossar Candidato"
                @click="empossarSelecionados"
                class="btn btn-success btn-xs"
                :disabled="!Boolean(dataBase) || loading.empossar"
              >
                <font-awesome-icon
                  v-if="loading.empossar"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'check-double'" />
                Empossar
                <span class="sr-only">Empossar Candidato</span>
              </button>
              <button
                title="Revogar Candidato"
                @click="revogarSelecionados"
                class="btn btn-danger btn-xs"
                :disabled="!Boolean(dataBase) || loading.revogar"
              >
                <font-awesome-icon
                  v-if="loading.revogar"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'times'" />
                Revogar
                <span class="sr-only">Revogar Candidato</span>
              </button>
              <button
                v-if="isCotas"
                title="Imprimir fichas"
                @click="imprimirFichas"
                class="btn btn-success btn-xs"
                :disabled="!itens.length"
              >
                <font-awesome-icon
                  v-if="loading.imprimir"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'print'" />
                Imprimir fichas
                <span class="sr-only">Imprimir fichas</span>
              </button>
            </div>
          </div>
        </template>

        <template slot="column_input" slot-scope="props">
          <input type="checkbox" v-model="props.rowData.checked" />
        </template>

        <template slot="rowrender" slot-scope="props">
          <button
            title="Nomear Candidato"
            class="btn btn-success"
            @click="nomear(props.rowData)"
            :disabled="props.rowData.processingClickEvent"
            v-if="props.rowData.status === 'Habilitado'"
          >
            <font-awesome-icon
              v-if="props.rowData.processingClickEvent"
              :icon="'spinner'"
              spin
            />
            <font-awesome-icon v-else :icon="'check'" />
            <span class="sr-only">Nomear Candidato</span>
          </button>
          <div v-else>
            <button
              title="Empossar Candidato"
              class="btn btn-success"
              @click="empossar(props.rowData)"
              :disabled="props.rowData.processingClickEvent"
              v-if="props.rowData.status === 'Nomeado'"
            >
              <font-awesome-icon
                v-if="props.rowData.processingClickEvent"
                :icon="'spinner'"
                spin
              />
              <font-awesome-icon v-else :icon="'check-double'" />
              <span class="sr-only">Empossar Candidato</span>
            </button>
            <button
              title="Revogar Candidato"
              class="btn btn-danger"
              @click="revogar(props.rowData)"
              :disabled="props.rowData.processingClickEvent"
              v-if="props.rowData.status === 'Nomeado'"
            >
              <font-awesome-icon
                v-if="props.rowData.processingClickEvent"
                :icon="'spinner'"
                spin
              />
              <font-awesome-icon v-else :icon="'times'" />
              <span class="sr-only">Revogar Candidato</span>
            </button>
          </div>
        </template>
      </data-table>
    </main>
  </section>
</template>

<script>
import { request } from '@/request'
import DataTable from '@/components/common/NoApiTable'
import Datepicker from '@/components/common/Datepicker'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'

export default {
  components: { DataTable, Datepicker },
  inject: ["showConfirm"],
  props: {
    id: {
      type: String,
      default() {
        return ''
      }
    },
    title: {
      type: String,
      default() {
        return 'Listagem'
      }
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    fullData: {
      type: Array,
      default: () => []
    },
    isCotas: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      dataBase: '',
      loading: {
        nomear: false,
        empossar: false,
        revogar: false,
        imprimir: false
      },
      hasAllCheckboxOnPage: false,
      lastPageSelected: 1,
      itens: [],
      fields: [
        {
          name: '__slot:input',
          title: '#',
          dataClass: 'text-center'
        },
        {
          name: 'classificacao',
          title: 'Classificação',
          dataClass: 'text-center'
        },
        {
          name: 'descricao',
          title: 'Cargo'
        },
        {
          name: 'nome',
          title: 'Nome'
        },
        {
          name: 'tipo_normal',
          title: 'Geral',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'tipo_pcd',
          title: 'PCD',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'tipo_cotas',
          title: 'Cotas',
          titleClass: 'text-center',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'status',
          title: 'Status'
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ]
    }
  },
  mounted() {
    this.setItens()
  },
  computed: {
    iconCheck() {
      return faSquare
    },
    iconChecked() {
      return faCheckSquare
    }
  },
  watch: {
    data: function(val, oldVal) {
      this.setItens()
    }
  },
  methods: {
    nomear({ index, id, nome }) {
      const { requestDataInvalid, dataBase } = this

      if (requestDataInvalid()) return

      const params = { id, data_nomeacao: dataBase.toISOString().split('T')[0] }
      const msgSuccess = `${nome} nomeado com sucesso`
      const msgError = `Houve um erro ao tentar nomear ${nome}, tente novamente daqui alguns minutos.`

      this.showConfirm(`Tem certeza que deseja nomear ${nome}`, {
        title: 'Alerta',
        question: true,
        yes: () =>
          this.sendRequestUpdate({
            index,
            params,
            msgSuccess,
            msgError,
            type: 'nomear'
          })
      })
    },
    empossar({ index, id, nome }) {
      const { requestDataInvalid, dataBase } = this

      if (requestDataInvalid()) return

      const params = {
        id,
        data_empossado: dataBase.toISOString().split('T')[0]
      }
      const msgSuccess = `${nome} empossado com sucesso`
      const msgError = `Houve um erro ao tentar empossar ${nome}, tente novamente daqui alguns minutos.`

      this.showConfirm(`Tem certeza que deseja empossar ${nome}`, {
        title: 'Alerta',
        question: true,
        yes: () =>
          this.sendRequestUpdate({
            index,
            params,
            msgSuccess,
            msgError,
            type: 'empossar'
          })
      })
    },
    revogar({ index, id, nome }) {
      const { requestDataInvalid, dataBase } = this

      if (requestDataInvalid()) return

      const params = {
        id,
        data_revogacao: dataBase.toISOString().split('T')[0]
      }
      const msgSuccess = `${nome} revogado com sucesso`
      const msgError = `Houve um erro ao tentar revogar ${nome}, tente novamente daqui alguns minutos.`

      this.showConfirm(`Tem certeza que deseja revogar ${nome}`, {
        title: 'Alerta',
        question: true,
        yes: () =>
          this.sendRequestUpdate({
            index,
            params,
            msgSuccess,
            msgError,
            type: 'revogar'
          })
      })
    },
    imprimirFichas() {
      const { edital_id } = this.itens[0]
      window.open(
        `${request.defaults.baseURL}habilitado/imprimir-fichas-cotas/${edital_id}`,
        '_blank'
      )
    },
    sendRequestUpdate({ index, params, msgSuccess, msgError, type }) {
      request
        .put(`habilitado/${params.id}`, params)
        .then(() => {
          this.itens[index].status = this.getStatus(type)
          this.$toastr.s(msgSuccess)
          this.toggleProcessingClickEvent(index)
        })
        .catch(() => this.$toastr.e(msgError))
        .finally(() => this.toggleProcessingClickEvent(index))
    },
    nomearSelecionados() {
      const nomes = this.filterItensSelected('Habilitado').map(
        ({ nome }) => nome
      )

      this.sendRequestUpdateMany({
        action: 'nomear',
        msgSuccess: 'Candidatos nomeados com sucesso',
        msgError:
          'Houve um erro ao tentar nomear os candidatos selecionados, tente novamente daqui alguns minutos.',
        confirmTitle: `${nomes.length} candidatos aptos a nomeação, confirme para concluir?`,
        confirmMsg: nomes.map(nome => `<p>${nome}</p>`).join('')
      })
    },
    empossarSelecionados() {
      const nomes = this.filterItensSelected('Nomeado').map(({ nome }) => nome)

      this.sendRequestUpdateMany({
        action: 'empossar',
        msgSuccess: 'Candidatos empossado com sucesso',
        msgError:
          'Houve um erro ao tentar empossar os candidatos selecionados, tente novamente daqui alguns minutos.',
        confirmTitle: `${nomes.length} candidatos aptos a empossamento, confirme para concluir?`,
        confirmMsg: nomes.map(nome => `<p>${nome}</p>`).join('')
      })
    },
    revogarSelecionados() {
      const nomes = this.filterItensSelected('Nomeado').map(({ nome }) => nome)

      this.sendRequestUpdateMany({
        action: 'revogar',
        msgSuccess: 'Candidatos revogados com sucesso',
        msgError:
          'Houve ao tentar revogar os candidatos selecionados, tente novamente daqui alguns minutos.',
        confirmTitle: `${nomes.length} candidatos aptos a revogação, confirme para concluir?`,
        confirmMsg: nomes.map(nome => `<p>${nome}</p>`).join('')
      })
    },
    sendRequestUpdateMany({
      action,
      msgSuccess,
      msgError,
      confirmTitle,
      confirmMsg
    }) {
      const {
        requestDataInvalid,
        getRequestParams,
        updateStatusRowsSelected,
        toggleLoadingActionButton,
        showConfirm
      } = this

      if (requestDataInvalid()) return

      const requestParams = getRequestParams(action)

      if (!requestParams) {
        this.$toastr.e('Não há candidatos habilitados selecionados!')
        return
      }

      const success = () => {
        toggleLoadingActionButton(action)
        request
          .put(`habilitados`, requestParams)
          .then(() => {
            updateStatusRowsSelected(this.getStatus(action))
            this.$toastr.s(msgSuccess)
          })
          .catch(() => this.$toastr.e(msgError))
          .finally(() => toggleLoadingActionButton(action))
      }

      showConfirm(confirmMsg, {
        title: confirmTitle,
        question: true,
        yes: success
      })
    },
    alternarTodosCheckboxNaPagina() {
      const statusCurrent = this.hasAllCheckboxOnPage

      this.$refs.vuetable.tableData.forEach(item => {
        item.checked = !statusCurrent
      })

      this.hasAllCheckboxOnPage = !statusCurrent
    },
    getRequestParams(type) {
      let statusDescricao = ''
      let dataProperty = ''

      switch (type) {
        case 'nomear':
          statusDescricao = 'Habilitado'
          dataProperty = 'data_nomeacao'
          break
        case 'empossar':
          statusDescricao = 'Nomeado'
          dataProperty = 'data_empossado'
          break
        default:
          statusDescricao = 'Nomeado'
          dataProperty = 'data_revogacao'
          break
      }

      const { itens, dataBase } = this
      const ids = itens
        .filter(({ checked, status }) => checked && status === statusDescricao)
        .map(({ id }) => id)

      if (ids.length === 0) return null

      return {
        ids,
        [dataProperty]: dataBase.toISOString().split('T')[0]
      }
    },
    filterItensSelected(status) {
      return this.itens.filter(item => item.checked && item.status === status)
    },
    setItens() {
      const { data, getStatus } = this
      this.itens = data.map((item, index) => ({
        index,
        checked: false,
        status: getStatus(item),
        processingClickEvent: false,
        ...item
      }))
    },
    toggleProcessingClickEvent(index) {
      const item = this.itens[index]
      this.itens[index].processingClickEvent = !item.processingClickEvent
    },
    toggleLoadingActionButton(type) {
      this.loading[type] = !this.loading[type]
    },
    updateStatusRowsSelected(statusNew) {
      let statusToSearch = 'Habilitado'

      if (['Empossado', 'Revogado'].find(i => i === statusNew))
        statusToSearch = 'Nomeado'

      const indexes = this.itens
        .filter(({ checked, status }) => checked && status === statusToSearch)
        .map(({ index }) => index)

      indexes.forEach(i => {
        this.itens[i].status = statusNew
        this.itens[i].checked = false
      })
    },
    checkOtherStatus(args) {
      const filter = item => {
        return (
          item.cpf === args.cpf &&
          item.data_nomeacao !== null &&
          item.cargo_id === args.cargo_id
        )
      }

      const result = this.fullData.filter(filter)

      if (result.length) {
        const [first] = result
        return `Nomeado ${
          first.tipo_normal ? 'Geral' : first.tipo_pcd ? 'PCD' : 'Negro'
        }`
      }

      return 'Habilitado'
    },
    getStatus(args) {
      if (typeof args === 'object') {
        if (args.data_empossado) {
          return 'Empossado'
        }

        if (args.data_revogacao) {
          return 'Revogado'
        }

        if (args.data_nomeacao) {
          return 'Nomeado'
        }

        return this.checkOtherStatus(args)
      }

      let status = ''

      switch (args) {
        case 'nomear':
          status = 'Nomeado'
          break
        case 'empossar':
          status = 'Empossado'
          break
        default:
          status = 'Revogado'
          break
      }

      return status
    },
    alternarLoadingActionButton() {
      this.loadingActionButton = !this.loadingActionButton
    },
    checkAllCheckboxOnPage() {
      const { tableData } = this.$refs.vuetable
      const countSelected = tableData
        .map(({ checked }) => +checked)
        .reduce((acc, cur) => acc + cur)

      this.hasAllCheckboxOnPage = countSelected === tableData.length
    },
    requestDataInvalid() {
      if (!this.dataBase) {
        this.$toastr.e('Selecione a data base para atualização')
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.button-group {
  display: flex;
}
.button-group > * {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/HabilitadoTable/index.vue